import { useAuthorization } from 'components/Authorization';
import { useCallback, useRef, useState } from 'react';
import Cache from 'utils/Cache';

const getKey = (userId?: number) => {
  return `PhraseTranslateOpened/${userId}`;
};

// 快捷回复翻译内容开关
export const usePhraseTranslateOpened = () => {
  const { payload } = useAuthorization<Oversea.Token.Payload>();

  const ref = useRef({
    cache: new Cache(localStorage, getKey(payload?.id)),
  });

  const [opened, setOpened] = useState(ref.current.cache.get<boolean>() ?? false);

  const onOpenedChange = useCallback(
    (value: boolean) => {
      ref.current.cache.set(value);
      setOpened(value);
    },
    [setOpened],
  );

  return {
    opened,
    onOpenedChange,
  };
};
